export default __webpack_public_path__ + "static/SK_securities-be0a8003c44396ab086ae3cc4d83e4c3.png";